<template>
  <div v-bem="{ isDimmed: dimmed && !$screen.lg }">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'Dimmable',
  props: {
    dimmed: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@use '~tokens/sass/utils';

.dimmable {
  transition: all 320ms;

  @at-root #{&}--is-dimmed {
    opacity: 0.3;
  }
}
</style>
